import { request } from '@langlois/request';

export async function getByClubId ({ commit }, clubId) {
	commit(`setCompetitions`, []);

	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/club/${clubId}/competition`);

		const response = await request.get(url);

		if (!response.ok || response.status === 204) return;

		const competitions = await response.json();

		commit(`setCompetitions`, competitions);
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the club's competitions.`,
			type: `warning`
		}, { root: true });
	}
}
